import React from 'react';

const About = () => {
    return (
        <div>
            <h1 className='font-bold text-4xl mt-7 bg-clip-text text-transparent bg-gradient-to-r from-red-500 to-blue-500'>About Me</h1>
            <p>I am Sarfaraj Shaikat. I set a goal for my life because i need to be a good developer. I have completed my Graduation last year. In future i fixed my goal which i have to implement.

                Ensure and make my goals clear to help me work towards achieving them. Instead of I want to learn interpersonal skills, I can set the objective of ensuring that i interact with at least 15 fellow developers every month.

                Learn to set milestones in the course of the journey towards the top of my carrier. I can develop the skills and experience you feel will make your developer profession grow. Set measurement as learning and focus on gaining a new skill every month.

                Technical talent alone does not offer satisfaction within a team, and other qualities are needed. Finding the best team that has the same professional goals as mine is essential in achieving my goals.</p>
        </div>
    );
};

export default About;